var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C18.6168 0 24 5.3832 24 12C24 18.6168 18.6168 24 12 24C5.3832 24 0 18.6168 0 12C0 5.3832 5.3832 0 12 0ZM12 1.8C6.3756 1.8 1.8 6.3756 1.8 12C1.8 17.6244 6.3756 22.2 12 22.2C17.6244 22.2 22.2 17.6244 22.2 12C22.2 6.3756 17.6244 1.8 12 1.8ZM11.5934 6.11448C12.0914 6.11448 12.4934 6.51768 12.4934 7.01448V12.3209L16.5794 14.7569C17.0054 15.0125 17.1458 15.5645 16.8914 15.9917C16.7222 16.2737 16.4234 16.4309 16.1174 16.4309C15.9602 16.4309 15.8018 16.3901 15.6566 16.3049L11.1326 13.6061C10.8614 13.4429 10.6934 13.1489 10.6934 12.8321V7.01448C10.6934 6.51768 11.0966 6.11448 11.5934 6.11448Z",
    fill: "#B6101D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/Time.9dd5fe0618a5692cd5c127ca3fc43a23.svg";
export { ForwardRef as ReactComponent };